/**
 * Build a vCard 3.0 string and trigger download / open.
 * Desktop: file download. iOS Safari: open blob so “Add to Contacts” appears.
 */
export function downloadVCard(profile) {
  const {
    firstName,
    lastName,
    fullName,
    title,
    email,
    phone,
    phoneTel,
    website,
    servicesNote,
    coverage,
  } = profile;

  const note = [servicesNote, coverage].filter(Boolean).join(' ');

  const lines = [
    'BEGIN:VCARD',
    'VERSION:3.0',
    `N:${escapeVCard(lastName)};${escapeVCard(firstName)};;;`,
    `FN:${escapeVCard(fullName)}`,
    title ? `TITLE:${escapeVCard(title)}` : null,
    'ORG:Andrea Fagioli',
    email ? `EMAIL;TYPE=INTERNET,PREF:${escapeVCard(email)}` : null,
    phone || phoneTel
      ? `TEL;TYPE=CELL,VOICE:${escapeVCard((phoneTel || phone).replace(/\s/g, ''))}`
      : null,
    website ? `URL:${escapeVCard(website)}` : null,
    note ? `NOTE:${escapeVCard(note)}` : null,
    'END:VCARD',
  ].filter(Boolean);

  const vcf = lines.join('\r\n');
  const blob = new Blob([vcf], { type: 'text/vcard;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const filename = `${slugify(fullName || 'contact')}.vcf`;
  const isIOS =
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  if (isIOS) {
    window.location.href = url;
    window.setTimeout(() => URL.revokeObjectURL(url), 4000);
    return;
  }

  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.rel = 'noopener';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

function escapeVCard(value) {
  return String(value)
    .replace(/\\/g, '\\\\')
    .replace(/;/g, '\\;')
    .replace(/,/g, '\\,')
    .replace(/\n/g, '\\n');
}

function slugify(value) {
  return String(value)
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '') || 'contact';
}
